import * as zod from 'zod';

export const bulkEditSchema = zod.record(
  zod.string(),
  zod
    .object({
      name: zod.string().max(160).trim().min(1).optional(),
      startDate: zod.date().optional().nullable(),
      endDate: zod.date().optional().nullable(),
      kpiId: zod.number().optional().nullable(),
      kpiGoal: zod.number().min(0).optional().nullable(),
      bidPrice: zod.number().min(0).optional().nullable(),
      minBidPrice: zod.number().min(0).optional().nullable(),
      pacing: zod.string().optional(),
      pacingGoal: zod.number().min(0).optional().nullable(),
      dailyCap: zod.number().min(0).optional().nullable(),
    })
    .superRefine((data, ctx) => {
      if (data.startDate && data.endDate && data.startDate > data.endDate) {
        return ctx.addIssue({
          path: ['startDate'],
          code: zod.ZodIssueCode.custom,
          message: 'Start date must be before end date',
        });
      }
    })
);
